export enum IncidentTypeEnum {
  SIGNATURE_SUBJECT_TO_CHANGE = 0,
  PROBLEMS_WITH_PICKUP = 1,
  PROBLEMS_WITH_DELIVERY = 2,
  LOSS_OF_SHIPMENT = 3,
}
